import config from '../../../../config';
import Request from '../../../Request';

export default function index(orderId, onSuccess, onFailure) {
  return Request.get(`${config.apiUrl}/orders/${orderId}/reservations`, onSuccess, onFailure);
}